/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

import { writable } from 'svelte/store';
import { __ } from '@oat-sa-private/ui-core';
import { DATE_FORMAT_CONFIG_CHANGE_EVENT } from '@oat-sa-private/ui-core/time';

/**
 * Bumps a version counter when locale or date-format config changes.
 * Components subscribe to re-render localized dates synchronously after preload.
 * @returns {Object} Locale version store
 */
function createLocaleVersionStore() {
    const { subscribe, update } = writable(0);

    const bump = () => {
        update(version => version + 1);
    };

    __.addEventListener('localechange', bump);

    if (typeof window !== 'undefined') {
        window.addEventListener(DATE_FORMAT_CONFIG_CHANGE_EVENT, bump);
    }

    return {
        subscribe
    };
}

export const localeVersionStore = createLocaleVersionStore();
